import { Component, ElementRef, EventEmitter, inject, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormControl } from '@angular/forms';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { PurIndentDetailDTO, PurIndentDetailCreateRequestDTO, PurIndentDetailByIndentAndVendorDTO } from 'src/app/purchase/indent-master/indent-detail/indent-detail.interface';
import { PurIndentMasterDTO } from 'src/app/purchase/indent-master/indent-master.interface';
import { IndentDetailService } from 'src/app/purchase/indent-master/indent-detail/indent-detail.service';
import { IndentMasterService } from 'src/app/purchase/indent-master/indent-master.service';

@Component({
  selector: 'app-add-via-indent-button',
  templateUrl: './add-via-indent-button.component.html',
  styleUrls: ['./add-via-indent-button.component.css']
})
export class AddViaIndentButtonComponent {
  // Inputs
  @Input() EnablePriceEdit: boolean = false;
  @Input({ required: true }) MasterId: number = 0;
  @Input({ required: true }) MasterType: string = '';
  @Input() ButtonName: string = 'Indent';

  @Input() selectedIndentId: number | null = null;
  @Input() selectedSupplierId: number | null = null;

  // Outputs
  @Output() onSubmit: EventEmitter<PurIndentDetailCreateRequestDTO[]> = new EventEmitter<PurIndentDetailCreateRequestDTO[]>();

  // Flags
  isSubmitting: boolean = false;
  dataLoading: boolean = false;
  searchLoading: boolean = false;
  ifItemsSelected: boolean = false;

  // Form Controls
  // IndentNo = new FormControl(0);

  // Services
  modalService = inject(NgbModal);
  User = inject(UserLoginService).User();
  IndentMasterService = inject(IndentMasterService);
  IndentDetailService = inject(IndentDetailService);

  // Data
  IndentList: PurIndentMasterDTO[] = [];
  IndentDetailItems: PurIndentDetailByIndentAndVendorDTO[] = [];
  filteredIndentDetailItems: PurIndentDetailByIndentAndVendorDTO[] = [];
  VendorList: { vendorId: number, vendorName: string }[] = [];
  SelectedDetailItems: PurIndentDetailCreateRequestDTO[] = [];
  selectedVendor: number | null = null;
  showVendorFilter: boolean = false;
  alertMessage: string = '';
  alertType: 'danger' | 'warning' | 'success' = 'danger';

  // Modal Ref
  IndentModalRef!: NgbModalRef;
  @ViewChild('IndentItemModal', { static: true }) IndentModalTemplate!: ElementRef;

  ngOnInit() {
    // this.IndentNo.valueChanges.subscribe(res => {
    //   if (res) {
    //     this.GetItemsByIndentId(Number(res));
    //   }
    // });
  }
  ngOnChanges(changes: SimpleChanges) {
    // Check if either selectedIndentId or selectedSupplierId has changed
    const indentIdChange = changes['selectedIndentId'];
    const supplierIdChange = changes['selectedSupplierId'];

    // Only fetch if both values are available and at least one has changed
    if ((indentIdChange || supplierIdChange) &&
      this.selectedIndentId &&
      this.selectedSupplierId) {

      const indentId = Number(this.selectedIndentId);
      const supplierId = Number(this.selectedSupplierId);

      // Only fetch if both IDs are valid (greater than 0)
      if (indentId > 0 && supplierId > 0) {
        this.GetItemsByIndentId(indentId, supplierId);
      }
    }
  }

  openModal() {
    // this.IndentNo.reset();
    // this.IndentList = [];
    // this.IndentDetailItems = [];
    // this.SelectedDetailItems = [];
    // this.searchLoading = true;
    // this.filteredIndentDetailItems = [];

    // this.IndentMasterService.IndentMaster_SearchByPurIndentNo({ companyId: this.User.companyId, branchId: this.User.loggedInBranchId, searchText: '' }).subscribe({
    //   next: (res: any) => {
    //     this.IndentList = res.items || [];
    //     this.searchLoading = false;




    //   },
    //   error: (err: any) => {
    //     console.error('Error loading indents:', err);
    //     this.searchLoading = false;
    //   }
    // });

    // Refresh on every open: nothing ticked, no vendor filter, no leftover alert.
    // The indent's lines are loaded by the parent (ngOnChanges), so they're kept, just unticked.
    this.SelectedDetailItems = [];
    this.ifItemsSelected = false;
    this.isSubmitting = false;
    this.selectedVendor = null;
    this.showVendorFilter = false;
    this.alertMessage = '';
    this.IndentDetailItems.forEach(i => i.isSelected = false);

    this.IndentModalRef = this.modalService.open(this.IndentModalTemplate, { size: 'lg', backdrop: 'static' });
  }

  SearchIndent(event: any) {
    const searchTerm = event.term?.toLowerCase() || '';
    this.searchLoading = true;

    this.IndentMasterService.IndentMaster_SearchByPurIndentNo({ tenantId: this.User.companyId, tenantBranchId: this.User.loggedInBranchId, searchText: searchTerm }).subscribe({
      next: (res: any) => {
        // Filter locally if API doesn't support search
        this.IndentList = (res.items || []).filter((item: PurIndentMasterDTO) =>
          item.indentNo?.toLowerCase().includes(searchTerm)
        );
        this.searchLoading = false;
      },
      error: (err: any) => {
        console.error('Error searching indents:', err);
        this.searchLoading = false;
      }
    });
  }

  GetItemsByIndentId(indentId: number, vendorId: number) {
    this.dataLoading = true;
    this.IndentDetailItems = [];
    this.filteredIndentDetailItems = [];
    this.SelectedDetailItems = [];
    this.ifItemsSelected = false;
    this.selectedVendor = null;
    this.showVendorFilter = false;

    this.IndentDetailService.IndentDetail_ReadByIndentAndVendor({
      indentId,
      vendorId,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
    }).subscribe({
      next: (res: any) => {
        this.IndentDetailItems = (res.items || []).map((item: PurIndentDetailByIndentAndVendorDTO) => ({
          ...item,
          isSelected: false,
          availableQty: item.qty
        }));
        this.filteredIndentDetailItems = [...this.IndentDetailItems];
        console.log('Loaded indent items:', this.IndentDetailItems);
        // this.VendorList = [];
        // this.IndentDetailItems.forEach(item => {
        //   if (item.vendorId && !this.VendorList.find(v => v.vendorId === item.vendorId)) {
        //     this.VendorList.push({ vendorId: item.vendorId, vendorName: item.vendorName || '' });
        //   }
        // })
        this.dataLoading = false;
      },
      error: (err: any) => {
        console.error('Error loading indent details:', err);
        this.dataLoading = false;
        this.IndentDetailItems = [];
        this.filteredIndentDetailItems = [];
      }
    });
  }

  onSelctionCheckboxChange(event: any, item: PurIndentDetailByIndentAndVendorDTO) {
    item.isSelected = event.target.checked;
    this.EnablePriceEdit = true

    if (event.target.checked) {
      const isDuplicate = this.SelectedDetailItems.find(i => i.indentId === item.indentId && i.itemId === item.itemId);
      if (!isDuplicate) {
        // Create full object with all necessary fields including extra ones for PO creation
        const detailItem: any = {
          // PurIndentDetailCreateRequestDTO fields
          indentId: item.indentId,
          itemId: item.itemId,
          qtyType: item.qtyType || '',
          qty: item.qty,
          reqQtyType: item.reqQtyType || '',
          reqQty: item.reqQty || 0,
          price: item.price || 0,
          totalAmount: item.totalAmount || 0,
          remarks: item.remarks || '',
          displaySeq: item.displaySeq || 0,
          otherDetail1: item.otherDetail1 || '',
          otherDetail2: item.otherDetail2 || '',
          otherDetail3: item.otherDetail3 || '',
          otherDetail4: item.otherDetail4 || '',
          otherDetail5: item.otherDetail5 || '',
          otherDetail6: item.otherDetail6 || '',
          actionUser: this.User.userId.toString(),
          // Extra fields for PO creation
          detailId: item.detailId,
          itemNo: item.itemNo,
          itemDetails: item.itemDetails,
        };
        this.SelectedDetailItems.push(detailItem);
      }
    } else {
      this.SelectedDetailItems = this.SelectedDetailItems.filter(i => !(i.indentId === item.indentId && i.itemId === item.itemId));
    }
    
    this.ifItemsSelected = this.SelectedDetailItems.length > 0;
  }

  onSelectAllCheckboxChange(event: any) {
    if (event.target.checked) {
      this.IndentDetailItems.forEach(item => {
        item.isSelected = true;
        const isDuplicate = this.SelectedDetailItems.find(i => i.indentId === item.indentId && i.itemId === item.itemId);
        if (!isDuplicate) {
          // Create full object with all necessary fields
          const detailItem: any = {
            // PurIndentDetailCreateRequestDTO fields
            indentId: item.indentId,
            itemId: item.itemId,
            qtyType: item.qtyType || '',
            qty: item.qty,
            reqQtyType: item.reqQtyType || '',
            reqQty: item.reqQty || 0,
            price: item.price || 0,
            totalAmount: item.totalAmount || 0,
            remarks: item.remarks || '',
            displaySeq: item.displaySeq || 0,
            otherDetail1: item.otherDetail1 || '',
            otherDetail2: item.otherDetail2 || '',
            otherDetail3: item.otherDetail3 || '',
            otherDetail4: item.otherDetail4 || '',
            otherDetail5: item.otherDetail5 || '',
            otherDetail6: item.otherDetail6 || '',
            actionUser: this.User.userId.toString(),
            // Extra fields for PO creation
            detailId: item.detailId,
            itemNo: item.itemNo,
            itemDetails: item.itemDetails,
          };
          this.SelectedDetailItems.push(detailItem);
        }
      });
    } else {
      const itemKeys = this.IndentDetailItems.map(i => ({ indentId: i.indentId, itemId: i.itemId }));
      this.SelectedDetailItems = this.SelectedDetailItems.filter(selected =>
        !itemKeys.some(key => key.indentId === selected.indentId && key.itemId === selected.itemId)
      );
      this.IndentDetailItems.forEach(item => {
        item.isSelected = false;
      });
    }

    this.ifItemsSelected = this.SelectedDetailItems.length > 0;
  }

  patchCommonPrice(event: any) {
    const price = Number(event.target.value) || 0;
    this.SelectedDetailItems.forEach(item => {
      item.price = price;
    });

    // Also update the items array for display
    this.IndentDetailItems.forEach(item => {
      if (item.isSelected) {
        item.price = price;
      }
    });
  }

  onVendorFilterChange() {
    if (this.selectedVendor === null || this.selectedVendor === undefined) {
      this.filteredIndentDetailItems = [...this.IndentDetailItems];
    } else {
      this.filteredIndentDetailItems = this.IndentDetailItems.filter(item => item.vendorId === this.selectedVendor);
    }
  }

  toggleVendorFilter() {
    this.showVendorFilter = !this.showVendorFilter;
  }

  /**
   * Validate and update quantity - capture value from event, validate it, then update model
   */
  validateAndUpdateQty(item: PurIndentDetailByIndentAndVendorDTO, event: any): void {
       const inputValue = Number(event.target.value) || 0;
    const maxQty = item.qty || 0; // Original quantity is the max allowed (availableQty holds the edited value)
    let validatedQty = inputValue;

    if (inputValue > maxQty) {
      // Limit to max available quantity
      validatedQty = maxQty;
      this.showAlert(`Maximum available quantity is ${maxQty}. Adjusted to the available limit.`, 'warning');
    } else if (inputValue < 0) {
      // Prevent negative quantities
      validatedQty = 0;
      this.showAlert('Quantity must be positive. Please enter a valid quantity.', 'warning');
    }

    // Update the model with validated value
    item.availableQty = validatedQty;

    // Update input to show the validated value
    event.target.value = validatedQty;
  }

  showAlert(message: string, type: 'danger' | 'warning' | 'success' = 'danger'): void {
    this.alertMessage = message;
    this.alertType = type;
    // Auto-dismiss after 4 seconds
    setTimeout(() => {
      this.alertMessage = '';
    }, 4000);
  }

  submitResults() {

    if (!this.SelectedDetailItems.length) {
      console.warn('No items selected');
      return;
    }

    // Sync the latest qty and price from the UI back to SelectedDetailItems
    // This ensures edits made in the modal are captured
    this.SelectedDetailItems.forEach((selectedItem: any) => {
      const currentItem = this.IndentDetailItems.find(i => i.indentId === selectedItem.indentId && i.itemId === selectedItem.itemId);
      if (currentItem) {
        // Use availableQty if it was edited (even if 0), otherwise use original qty
        // Use nullish coalescing (??) instead of || to handle 0 values correctly
        selectedItem.qty = currentItem.availableQty ?? currentItem.qty;
        selectedItem.price = currentItem.price;
      }
    });

    // Validate: Check if any item has qty exceeding the original available quantity
    const invalidItems = this.SelectedDetailItems.filter((item: any) => {
      const originalItem = this.IndentDetailItems.find(i => i.indentId === item.indentId && i.itemId === item.itemId);
      // Fractional quantities (e.g. 0.3 Kgs) are valid; only zero/negative is rejected
      return originalItem && (item.qty > originalItem.qty || item.qty <= 0);
    });

    if (invalidItems.length > 0) {
      console.error('Validation failed - quantities exceed available amount or are invalid:', invalidItems);
      alert('Error: Quantity cannot exceed available amount and must be greater than 0. Please correct the highlighted items.');
      return;
    }

    console.log('===== SUBMIT FROM ADD-VIA-INDENT-BUTTON =====');
    console.log('SelectedDetailItems being emitted:', this.SelectedDetailItems);
    console.log('Sample item qty values:', this.SelectedDetailItems.map((item: any, i: number) => ({
      index: i,
      itemNo: item.itemNo,
      itemDetails: item.itemDetails,
      qty: item.qty,
      qtyType: item.qtyType,
      price: item.price
    })));

    this.isSubmitting = true;
    this.onSubmit.emit(this.SelectedDetailItems);
    // Close modal after emitting
    setTimeout(() => {
      this.IndentModalRef.close();
      this.isSubmitting = false;
      this.SelectedDetailItems = [];
    }, 500);
  }
}
